<div class="job-list page traveler">
  <div class="row filter-row">
    <mat-form-field class="bordered-select">
      <mat-label>Filter Job Type</mat-label>
      <mat-select [(ngModel)]="scope_job_type">
        <mat-option [value]="null">All</mat-option>
        @for (job_type of job_options; track job_type) {
          <mat-option [value]="job_type.key">
            {{job_type.name  | upperfirst}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field class="bordered-select">
      <mat-label>Filter Job Status</mat-label>
      <mat-select [(ngModel)]="scope_job_status">
        <mat-option [value]="null">All</mat-option>
        @for (status of status_options; track status) {
          <mat-option [value]="status">
            {{status | upperfirst}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <div class="date-filter">
      <label>Filter by submitted on</label>
      <date-time-picker class="date-time-picker" [input_date]="created_date" (date_changed)="created_date=$event"
                        [nowButton]="false" [show_time]="false"
                        [placeholder]="'Select date'"
                        ></date-time-picker>
    </div>

    <div class="date-filter">
      <label>Filter by submitted on</label>
    <date-time-picker class="date-time-picker" [input_date]="updated_date" (date_changed)="updated_date=$event"
                      [nowButton]="false" [show_time]="false"
                      [placeholder]="'Select date'"></date-time-picker>
    </div>
  </div>
  <src-jobs-table [scopeType]="scope_job_type" [status]="scope_job_status" [createdOn]="created_date"
                  [changedOn]="updated_date"></src-jobs-table>
</div>
